/**
 * urlHelper.js
 * Created by michaelbray on 2/14/18.
 */

import { logError } from './loggingHelper';

let lastId = 0;

export function isEmpty(str) {
    return (str === null || str.length === 0);
}

// This is needed to compensate for fetch's lack of url parameter management without string interpolation
export function urlWithParams(urlString, params = {}) {
    let searchParams = "";

    Object.keys(params).forEach((key) => {
        let sep = "";

        if (searchParams !== "") {
            sep = "&";
        }

        if (params[key] || params[key] === 0 || params[key] === false) {
            const val = params[key];

            if (!isEmpty(val) || val === 0 || val === false) {
                if (Array.isArray(val)) {
                    val.forEach((v) => {
                        if (searchParams !== "") {
                            sep = "&";
                        }
                        searchParams = `${searchParams}${sep}${key}=${encodeURIComponent(v)}`;
                    });
                }
                else {
                    searchParams = `${searchParams}${sep}${key}=${encodeURIComponent(val)}`;
                }
            }
        }
    });

    let ret = urlString;

    if (!isEmpty(searchParams)) {
        ret = `${ret}?${searchParams}`;
    }

    return ret;
}

export function newId(prefix = "id") {
    lastId += 1;
    return `${prefix}${lastId}`;
}

// parse fetch response to json
export function toJSON(response) {
    return response.json();
}

// fetch doesn't handle errors well
export function status(response) {
    if (response.status >= 200 && response.status < 300) {
        return Promise.resolve(response);
    }

    logError(response.statusText);
    return response.toJSON()
        .catch(() => {
            const error = new Error(response.statusText);
            error.response = response;
            // throw error
            return Promise.resolve(response);
        }).then((json) => {
            const error = new Error(json || response.statusText);
            error.response = response;
            // throw error
            return Promise.resolve(json);
        });
}
